<template>
  <div class="content">
    <h1 class="has-text-centered">ASCII Zeichentabelle</h1>
    <div class="box">
      <p>
        Der <strong>A</strong>merican <strong>S</strong>tandard <strong>C</strong>ode for <strong>I</strong>nformation <strong>I</strong>nterchange (kurz <strong>ASCII</strong>) ist eine <strong>7-Bit-Zeichenkodierung</strong> und dient als <strong>Grundlage für auf Bits basierende Kodierungen</strong> für Zeichensätze.
      </p>
      <p>
        <font-awesome-icon icon="arrow-circle-right" />
        <a href="https://de.wikipedia.org/wiki/American_Standard_Code_for_Information_Interchange" target="_blank" class="pl-2">Wikipedia-Artikel zu ASCII</a>
      </p>
      <div class="has-overflow-x-auto mb-3">
        <table class="table is-hoverable is-striped is-fullwidth">
          <thead>
            <tr>
              <th>ASCII-Wert</th>
              <th>Zeichen</th>
              <th>Erklärung</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0</td>
              <td>Ctrl-@</td>
              <td>Nul prompt</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Ctrl-A</td>
              <td>Start of heading</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Ctrl-B</td>
              <td>Start of text</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Ctrl-C</td>
              <td>End of text</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Ctrl-D</td>
              <td>End of transmission</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Ctrl-E</td>
              <td>Enquiry</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Ctrl-F</td>
              <td>Acknowledge</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Ctrl-G</td>
              <td>Bell</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Ctrl-H</td>
              <td>Backspace</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Ctrl-I</td>
              <td>Horizontal tab</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Ctrl-J</td>
              <td>Line feed</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Ctrl-K</td>
              <td>Vertical tab</td>
            </tr>
            <tr>
              <td>12</td>
              <td>Ctrl-L</td>
              <td>Form feed (New Page)</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Ctrl-M</td>
              <td>Carriage return</td>
            </tr>
            <tr>
              <td>14</td>
              <td>Ctrl-N</td>
              <td>Shift out</td>
            </tr>
            <tr>
              <td>15</td>
              <td>Ctrl-O</td>
              <td>Shift in</td>
            </tr>
            <tr>
              <td>16</td>
              <td>Ctrl-P</td>
              <td>Data link escape</td>
            </tr>
            <tr>
              <td>17</td>
              <td>Ctrl-Q</td>
              <td>X-ON</td>
            </tr>
            <tr>
              <td>18</td>
              <td>Ctrl-R</td>
              <td>-</td>
            </tr>
            <tr>
              <td>19</td>
              <td>Ctrl-S</td>
              <td>X-OFF</td>
            </tr>
            <tr>
              <td>20</td>
              <td>Ctrl-T</td>
              <td>-</td>
            </tr>
            <tr>
              <td>21</td>
              <td>Ctrl-U</td>
              <td>No acknowledge</td>
            </tr>
            <tr>
              <td>22</td>
              <td>Ctrl-V</td>
              <td>Synchronous idle</td>
            </tr>
            <tr>
              <td>23</td>
              <td>Ctrl-W</td>
              <td>End transmission blocks</td>
            </tr>
            <tr>
              <td>24</td>
              <td>Ctrl-X</td>
              <td>Cancel</td>
            </tr>
            <tr>
              <td>25</td>
              <td>Ctrl-Y</td>
              <td>End of medium</td>
            </tr>
            <tr>
              <td>26</td>
              <td>Ctrl-Z</td>
              <td>Sustitute</td>
            </tr>
            <tr>
              <td>27</td>
              <td>Ctrl-[</td>
              <td>Escape</td>
            </tr>
            <tr>
              <td>28</td>
              <td>Ctrl-\</td>
              <td>File separator</td>
            </tr>
            <tr>
              <td>29</td>
              <td>Ctrl-]</td>
              <td>Group separator</td>
            </tr>
            <tr>
              <td>30</td>
              <td>Ctrl-^</td>
              <td>Record separator</td>
            </tr>
            <tr>
              <td>31</td>
              <td>Ctrl-_</td>
              <td>Unit separator</td>
            </tr>
            <tr>
              <td>32</td>
              <td>-</td>
              <td>Leertaste</td>
            </tr>
            <tr>
              <td>33</td>
              <td>!</td>
              <td>Ausrufezeichen</td>
            </tr>
            <tr>
              <td>34</td>
              <td>"</td>
              <td>Anführungszeichen</td>
            </tr>
            <tr>
              <td>35</td>
              <td>#</td>
              <td>Doppelkreuz</td>
            </tr>
            <tr>
              <td>36</td>
              <td>$</td>
              <td>Dollar</td>
            </tr>
            <tr>
              <td>37</td>
              <td>%</td>
              <td>Prozent</td>
            </tr>
            <tr>
              <td>38</td>
              <td>&</td>
              <td>UND-Zeichen</td>
            </tr>
            <tr>
              <td>39</td>
              <td>'</td>
              <td>Apostroph</td>
            </tr>
            <tr>
              <td>40</td>
              <td>(</td>
              <td>runde öffnende Klammer</td>
            </tr>
            <tr>
              <td>41</td>
              <td>)</td>
              <td>runde schließende Klammer</td>
            </tr>
            <tr>
              <td>42</td>
              <td>*</td>
              <td>Stern</td>
            </tr>
            <tr>
              <td>43</td>
              <td>+</td>
              <td>Plus</td>
            </tr>
            <tr>
              <td>44</td>
              <td>,</td>
              <td>Komma</td>
            </tr>
            <tr>
              <td>45</td>
              <td>-</td>
              <td>Minus</td>
            </tr>
            <tr>
              <td>46</td>
              <td>0</td>
              <td>Punkt</td>
            </tr>
            <tr>
              <td>47</td>
              <td>/</td>
              <td>Schrägstrich</td>
            </tr>
            <tr>
              <td>48</td>
              <td>0</td>
              <td>Ziffer 0</td>
            </tr>
            <tr>
              <td>49</td>
              <td>1</td>
              <td>Ziffer 1</td>
            </tr>
            <tr>
              <td>50</td>
              <td>2</td>
              <td>Ziffer 2</td>
            </tr>
            <tr>
              <td>51</td>
              <td>3</td>
              <td>Ziffer 3</td>
            </tr>
            <tr>
              <td>52</td>
              <td>4</td>
              <td>Ziffer 4</td>
            </tr>
            <tr>
              <td>53</td>
              <td>5</td>
              <td>Ziffer 5</td>
            </tr>
            <tr>
              <td>54</td>
              <td>6</td>
              <td>Ziffer 6</td>
            </tr>
            <tr>
              <td>55</td>
              <td>7</td>
              <td>Ziffer 7</td>
            </tr>
            <tr>
              <td>56</td>
              <td>8</td>
              <td>Ziffer 8</td>
            </tr>
            <tr>
              <td>57</td>
              <td>9</td>
              <td>Ziffer 9</td>
            </tr>
            <tr>
              <td>58</td>
              <td>:</td>
              <td>Doppelpunkt</td>
            </tr>
            <tr>
              <td>59</td>
              <td>;</td>
              <td>Semikolon</td>
            </tr>
            <tr>
              <td>60</td>
              <td></td>
              <td>Kleiner</td>
            </tr>
            <tr>
              <td>61</td>
              <td>=</td>
              <td>Gleich</td>
            </tr>
            <tr>
              <td>62</td>
              <td>></td>
              <td>Grösser</td>
            </tr>
            <tr>
              <td>63</td>
              <td>?</td>
              <td>Fragezeichen</td>
            </tr>
            <tr>
              <td>64</td>
              <td>@</td>
              <td>At-Zeichen</td>
            </tr>
            <tr>
              <td>65</td>
              <td>A</td>
              <td>Großbuchstabe A</td>
            </tr>
            <tr>
              <td>66</td>
              <td>B</td>
              <td>Großbuchstabe B</td>
            </tr>
            <tr>
              <td>67</td>
              <td>C</td>
              <td>Großbuchstabe C</td>
            </tr>
            <tr>
              <td>68</td>
              <td>D</td>
              <td>Großbuchstabe D</td>
            </tr>
            <tr>
              <td>69</td>
              <td>E</td>
              <td>Großbuchstabe E</td>
            </tr>
            <tr>
              <td>70</td>
              <td>F</td>
              <td>Großbuchstabe F</td>
            </tr>
            <tr>
              <td>71</td>
              <td>G</td>
              <td>Großbuchstabe G</td>
            </tr>
            <tr>
              <td>72</td>
              <td>H</td>
              <td>Großbuchstabe H</td>
            </tr>
            <tr>
              <td>73</td>
              <td>I</td>
              <td>Großbuchstabe I</td>
            </tr>
            <tr>
              <td>74</td>
              <td>J</td>
              <td>Großbuchstabe J</td>
            </tr>
            <tr>
              <td>75</td>
              <td>K</td>
              <td>Großbuchstabe K</td>
            </tr>
            <tr>
              <td>76</td>
              <td>L</td>
              <td>Großbuchstabe L</td>
            </tr>
            <tr>
              <td>77</td>
              <td>M</td>
              <td>Großbuchstabe M</td>
            </tr>
            <tr>
              <td>78</td>
              <td>N</td>
              <td>Großbuchstabe N</td>
            </tr>
            <tr>
              <td>79</td>
              <td>O</td>
              <td>Großbuchstabe O</td>
            </tr>
            <tr>
              <td>80</td>
              <td>P</td>
              <td>Großbuchstabe P</td>
            </tr>
            <tr>
              <td>81</td>
              <td>Q</td>
              <td>Großbuchstabe Q</td>
            </tr>
            <tr>
              <td>82</td>
              <td>R</td>
              <td>Großbuchstabe R</td>
            </tr>
            <tr>
              <td>83</td>
              <td>S</td>
              <td>Großbuchstabe S</td>
            </tr>
            <tr>
              <td>84</td>
              <td>T</td>
              <td>Großbuchstabe T</td>
            </tr>
            <tr>
              <td>85</td>
              <td>U</td>
              <td>Großbuchstabe U</td>
            </tr>
            <tr>
              <td>86</td>
              <td>V</td>
              <td>Großbuchstabe V</td>
            </tr>
            <tr>
              <td>87</td>
              <td>W</td>
              <td>Großbuchstabe W</td>
            </tr>
            <tr>
              <td>88</td>
              <td>X</td>
              <td>Großbuchstabe X</td>
            </tr>
            <tr>
              <td>89</td>
              <td>Y</td>
              <td>Großbuchstabe Y</td>
            </tr>
            <tr>
              <td>90</td>
              <td>Z</td>
              <td>Großbuchstabe Z</td>
            </tr>
            <tr>
              <td>91</td>
              <td>[</td>
              <td>eckige Klammer auf</td>
            </tr>
            <tr>
              <td>92</td>
              <td>\</td>
              <td>Backslash</td>
            </tr>
            <tr>
              <td>93</td>
              <td>]</td>
              <td>eckige Klammer zu</td>
            </tr>
            <tr>
              <td>94</td>
              <td>^</td>
              <td>Potenz</td>
            </tr>
            <tr>
              <td>95</td>
              <td>_</td>
              <td>Unterstrich</td>
            </tr>
            <tr>
              <td>96</td>
              <td>`</td>
              <td>Akzent</td>
            </tr>
            <tr>
              <td>97</td>
              <td>a</td>
              <td>Kleinbuchstabe A</td>
            </tr>
            <tr>
              <td>98</td>
              <td>b</td>
              <td>Kleinbuchstabe B</td>
            </tr>
            <tr>
              <td>99</td>
              <td>c</td>
              <td>Kleinbuchstabe C</td>
            </tr>
            <tr>
              <td>100</td>
              <td>d</td>
              <td>Kleinbuchstabe D</td>
            </tr>
            <tr>
              <td>101</td>
              <td>e</td>
              <td>Kleinbuchstabe E</td>
            </tr>
            <tr>
              <td>102</td>
              <td>f</td>
              <td>Kleinbuchstabe F</td>
            </tr>
            <tr>
              <td>103</td>
              <td>g</td>
              <td>Kleinbuchstabe G</td>
            </tr>
            <tr>
              <td>104</td>
              <td>h</td>
              <td>Kleinbuchstabe H</td>
            </tr>
            <tr>
              <td>105</td>
              <td>i</td>
              <td>Kleinbuchstabe I</td>
            </tr>
            <tr>
              <td>106</td>
              <td>j</td>
              <td>Kleinbuchstabe J</td>
            </tr>
            <tr>
              <td>107</td>
              <td>k</td>
              <td>Kleinbuchstabe K</td>
            </tr>
            <tr>
              <td>108</td>
              <td>l</td>
              <td>Kleinbuchstabe L</td>
            </tr>
            <tr>
              <td>109</td>
              <td>m</td>
              <td>Kleinbuchstabe M</td>
            </tr>
            <tr>
              <td>110</td>
              <td>n</td>
              <td>Kleinbuchstabe N</td>
            </tr>
            <tr>
              <td>111</td>
              <td>o</td>
              <td>Kleinbuchstabe O</td>
            </tr>
            <tr>
              <td>112</td>
              <td>p</td>
              <td>Kleinbuchstabe P</td>
            </tr>
            <tr>
              <td>113</td>
              <td>q</td>
              <td>Kleinbuchstabe Q</td>
            </tr>
            <tr>
              <td>114</td>
              <td>r</td>
              <td>Kleinbuchstabe R</td>
            </tr>
            <tr>
              <td>115</td>
              <td>s</td>
              <td>Kleinbuchstabe S</td>
            </tr>
            <tr>
              <td>116</td>
              <td>t</td>
              <td>Kleinbuchstabe T</td>
            </tr>
            <tr>
              <td>117</td>
              <td>u</td>
              <td>Kleinbuchstabe U</td>
            </tr>
            <tr>
              <td>118</td>
              <td>v</td>
              <td>Kleinbuchstabe V</td>
            </tr>
            <tr>
              <td>119</td>
              <td>w</td>
              <td>Kleinbuchstabe W</td>
            </tr>
            <tr>
              <td>120</td>
              <td>x</td>
              <td>Kleinbuchstabe X</td>
            </tr>
            <tr>
              <td>121</td>
              <td>y</td>
              <td>Kleinbuchstabe Y</td>
            </tr>
            <tr>
              <td>122</td>
              <td>z</td>
              <td>Kleinbuchstabe Z</td>
            </tr>
            <tr>
              <td>123</td>
              <td>{</td>
              <td>geschweifte Klammer auf</td>
            </tr>
            <tr>
              <td>124</td>
              <td>|</td>
              <td>senkrechter Strich</td>
            </tr>
            <tr>
              <td>125</td>
              <td>}</td>
              <td>geschweifte Klammer zu</td>
            </tr>
            <tr>
              <td>126</td>
              <td>~</td>
              <td>Tilde</td>
            </tr>
            <tr>
              <td>127</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>128</td>
              <td>Ç</td>
              <td>-</td>
            </tr>
            <tr>
              <td>129</td>
              <td>ü</td>
              <td>-</td>
            </tr>
            <tr>
              <td>130</td>
              <td>é</td>
              <td>-</td>
            </tr>
            <tr>
              <td>131</td>
              <td>â</td>
              <td>-</td>
            </tr>
            <tr>
              <td>132</td>
              <td>ä</td>
              <td>-</td>
            </tr>
            <tr>
              <td>133</td>
              <td>à</td>
              <td>-</td>
            </tr>
            <tr>
              <td>134</td>
              <td>å</td>
              <td>-</td>
            </tr>
            <tr>
              <td>135</td>
              <td>ç</td>
              <td>-</td>
            </tr>
            <tr>
              <td>136</td>
              <td>ê</td>
              <td>-</td>
            </tr>
            <tr>
              <td>137</td>
              <td>ë</td>
              <td>-</td>
            </tr>
            <tr>
              <td>138</td>
              <td>è</td>
              <td>-</td>
            </tr>
            <tr>
              <td>139</td>
              <td>ï</td>
              <td>-</td>
            </tr>
            <tr>
              <td>140</td>
              <td>î</td>
              <td>-</td>
            </tr>
            <tr>
              <td>141</td>
              <td>ì</td>
              <td>-</td>
            </tr>
            <tr>
              <td>142</td>
              <td>Ä</td>
              <td>-</td>
            </tr>
            <tr>
              <td>143</td>
              <td>Å</td>
              <td>-</td>
            </tr>
            <tr>
              <td>144</td>
              <td>É</td>
              <td>-</td>
            </tr>
            <tr>
              <td>145</td>
              <td>æ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>146</td>
              <td>Æ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>147</td>
              <td>ô</td>
              <td>-</td>
            </tr>
            <tr>
              <td>148</td>
              <td>ö</td>
              <td>-</td>
            </tr>
            <tr>
              <td>149</td>
              <td>ò</td>
              <td>-</td>
            </tr>
            <tr>
              <td>150</td>
              <td>û</td>
              <td>-</td>
            </tr>
            <tr>
              <td>151</td>
              <td>ù</td>
              <td>-</td>
            </tr>
            <tr>
              <td>152</td>
              <td>ÿ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>153</td>
              <td>Ö</td>
              <td>-</td>
            </tr>
            <tr>
              <td>154</td>
              <td>Ü</td>
              <td>-</td>
            </tr>
            <tr>
              <td>155</td>
              <td>ø</td>
              <td>-</td>
            </tr>
            <tr>
              <td>156</td>
              <td>£</td>
              <td>Englisches Pfund</td>
            </tr>
            <tr>
              <td>157</td>
              <td>Ø</td>
              <td>-</td>
            </tr>
            <tr>
              <td>158</td>
              <td>×</td>
              <td>Multiplikation</td>
            </tr>
            <tr>
              <td>159</td>
              <td>ƒ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>160</td>
              <td>á</td>
              <td>-</td>
            </tr>
            <tr>
              <td>161</td>
              <td>í</td>
              <td>-</td>
            </tr>
            <tr>
              <td>162</td>
              <td>ó</td>
              <td>-</td>
            </tr>
            <tr>
              <td>163</td>
              <td>ú</td>
              <td>-</td>
            </tr>
            <tr>
              <td>164</td>
              <td>ñ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>165</td>
              <td>Ñ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>166</td>
              <td>ª</td>
              <td>-</td>
            </tr>
            <tr>
              <td>167</td>
              <td>º</td>
              <td>-</td>
            </tr>
            <tr>
              <td>168</td>
              <td>¿</td>
              <td>-</td>
            </tr>
            <tr>
              <td>169</td>
              <td>®</td>
              <td>Registrierte Marke</td>
            </tr>
            <tr>
              <td>170</td>
              <td>¬</td>
              <td>-</td>
            </tr>
            <tr>
              <td>171</td>
              <td>½</td>
              <td>1/2 Zeichen</td>
            </tr>
            <tr>
              <td>172</td>
              <td>¼</td>
              <td>1/4 Zeichen</td>
            </tr>
            <tr>
              <td>173</td>
              <td>¡</td>
              <td>-</td>
            </tr>
            <tr>
              <td>174</td>
              <td>«</td>
              <td>Doppelklammer auf</td>
            </tr>
            <tr>
              <td>175</td>
              <td>»</td>
              <td>Doppelklammer zu</td>
            </tr>
            <tr>
              <td>176</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>177</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>178</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>179</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>180</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>181</td>
              <td>Á</td>
              <td>-</td>
            </tr>
            <tr>
              <td>182</td>
              <td>Â</td>
              <td>-</td>
            </tr>
            <tr>
              <td>183</td>
              <td>À</td>
              <td>-</td>
            </tr>
            <tr>
              <td>184</td>
              <td>©</td>
              <td>Copyright</td>
            </tr>
            <tr>
              <td>185</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>186</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>187</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>188</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>189</td>
              <td>¢</td>
              <td>-</td>
            </tr>
            <tr>
              <td>190</td>
              <td>¥</td>
              <td>-</td>
            </tr>
            <tr>
              <td>191</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>192</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>193</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>194</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>195</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>196</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>197</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>198</td>
              <td>ã</td>
              <td>-</td>
            </tr>
            <tr>
              <td>199</td>
              <td>Ã</td>
              <td>-</td>
            </tr>
            <tr>
              <td>200</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>201</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>202</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>203</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>204</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>205</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td>206</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>207</td>
              <td>¤</td>
              <td>-</td>
            </tr>
            <tr>
              <td>208</td>
              <td>ð</td>
              <td>-</td>
            </tr>
            <tr>
              <td>209</td>
              <td>Ð</td>
              <td>-</td>
            </tr>
            <tr>
              <td>210</td>
              <td>Ê</td>
              <td>-</td>
            </tr>
            <tr>
              <td>211</td>
              <td>Ë</td>
              <td>-</td>
            </tr>
            <tr>
              <td>212</td>
              <td>È</td>
              <td>-</td>
            </tr>
            <tr>
              <td>213</td>
              <td>i</td>
              <td>-</td>
            </tr>
            <tr>
              <td>214</td>
              <td>Í</td>
              <td>-</td>
            </tr>
            <tr>
              <td>215</td>
              <td>Î</td>
              <td>-</td>
            </tr>
            <tr>
              <td>216</td>
              <td>Ï</td>
              <td>-</td>
            </tr>
            <tr>
              <td>217</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>218</td>
              <td>+</td>
              <td>-</td>
            </tr>
            <tr>
              <td>219</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>220</td>
              <td>_</td>
              <td>-</td>
            </tr>
            <tr>
              <td>221</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>222</td>
              <td>Ì</td>
              <td>-</td>
            </tr>
            <tr>
              <td>223</td>
              <td>¯</td>
              <td>-</td>
            </tr>
            <tr>
              <td>224</td>
              <td>Ó</td>
              <td>-</td>
            </tr>
            <tr>
              <td>225</td>
              <td>ß</td>
              <td>-</td>
            </tr>
            <tr>
              <td>226</td>
              <td>Ô</td>
              <td>-</td>
            </tr>
            <tr>
              <td>227</td>
              <td>Ò</td>
              <td>-</td>
            </tr>
            <tr>
              <td>228</td>
              <td>õ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>229</td>
              <td>Õ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>230</td>
              <td>µ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>231</td>
              <td>þ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>232</td>
              <td>Þ</td>
              <td>-</td>
            </tr>
            <tr>
              <td>233</td>
              <td>Ú</td>
              <td>-</td>
            </tr>
            <tr>
              <td>234</td>
              <td>Û</td>
              <td>-</td>
            </tr>
            <tr>
              <td>235</td>
              <td>Ù</td>
              <td>-</td>
            </tr>
            <tr>
              <td>236</td>
              <td>ý</td>
              <td>-</td>
            </tr>
            <tr>
              <td>237</td>
              <td>Ý</td>
              <td>-</td>
            </tr>
            <tr>
              <td>238</td>
              <td>¯</td>
              <td>-</td>
            </tr>
            <tr>
              <td>239</td>
              <td>´</td>
              <td>-</td>
            </tr>
            <tr>
              <td>240</td>
              <td></td>
              <td>-</td>
            </tr>
            <tr>
              <td>241</td>
              <td>±</td>
              <td>Plus/Minus</td>
            </tr>
            <tr>
              <td>242</td>
              <td>=</td>
              <td>Gleichheitszeichen</td>
            </tr>
            <tr>
              <td>243</td>
              <td>¾</td>
              <td>3/4 Zeichen</td>
            </tr>
            <tr>
              <td>244</td>
              <td>¶</td>
              <td>Absatz</td>
            </tr>
            <tr>
              <td>245</td>
              <td>§</td>
              <td>Paragraph</td>
            </tr>
            <tr>
              <td>246</td>
              <td>÷</td>
              <td>Dividierzeichen</td>
            </tr>
            <tr>
              <td>247</td>
              <td>¸</td>
              <td>-</td>
            </tr>
            <tr>
              <td>248</td>
              <td>°</td>
              <td>Grad</td>
            </tr>
            <tr>
              <td>249</td>
              <td>¨</td>
              <td>-</td>
            </tr>
            <tr>
              <td>250</td>
              <td>·</td>
              <td>-</td>
            </tr>
            <tr>
              <td>251</td>
              <td>¹</td>
              <td>Hochgestellte 1</td>
            </tr>
            <tr>
              <td>252</td>
              <td>³</td>
              <td>Hochgestellte 3</td>
            </tr>
            <tr>
              <td>253</td>
              <td>²</td>
              <td>Hochgestellte 2</td>
            </tr>
            <tr>
              <td>254</td>
              <td>¦</td>
              <td>-</td>
            </tr>
            <tr>
              <td>255</td>
              <td>-</td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <FeedbackBox />

    <GeneralAffiliateBox />

  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import GeneralAffiliateBox from '@/components/GeneralAffiliateBox.vue'

export default {
  name: 'tables-ascii-characters',
  components: {
    FeedbackBox,
    GeneralAffiliateBox
  },
  metaInfo: {
    title: 'ASCII Tabelle | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'ASCII (American Standard Code for Information Interchange) ist eine 7-Bit-Zeichenkodierung.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
